(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function () {
  const audio = document.querySelector('audio');
  const lyrics = document.querySelector('#lyrics');
  const lines = lyrics?.querySelectorAll('span[data-times]');
  if (!audio || !lyrics || !lines) {
    return;
  }
  audio.addEventListener('timeupdate', function () {
    const {
      currentTime
    } = audio;
    for (const line of lines) {
      const timesString = line.dataset.times;
      const times = timesString?.split(',').map(t => Number.parseFloat(t.trim()));
      const duration = Number.parseFloat(line.dataset.duration ?? '0');
      if (times) {
        let isActive = false;
        for (const startTime of times) {
          const endTime = startTime + duration;
          if (currentTime >= startTime && currentTime < endTime) {
            isActive = true;
            break;
          }
        }
        if (isActive) {
          line.classList.add('active');
        } else {
          line.classList.remove('active');
        }
      }
    }
  });
  // Click or press Enter/Space to jump to line times
  const jumpTo = async line => {
    const times = line.dataset.times?.split(',').map(t => Number.parseFloat(t.trim()));
    if (times) {
      audio.currentTime = times[0];
      await audio.play();
    }
  };
  for (const line of lines) {
    line.tabIndex = 0;
    line.setAttribute('role', 'button');
    line.addEventListener('click', async () => {
      await jumpTo(line);
    });
    line.addEventListener('keydown', async event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        await jumpTo(line);
      }
    });
  }
})();

},{}]},{},[1])

//# sourceMappingURL=feel.js.map
